var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationLogoThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#D0E5EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 15C23.5817 15 20 18.5817 20 23H36C36 18.5817 32.4183 15 28 15Z",
    fill: "#AACED9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 43.9731V32H14V52.2541C10.4253 50.1862 7.35015 47.3508 5 43.9731ZM17 53.7566V26H39V53.7566C35.6232 55.2006 31.9049 56 28 56C24.0951 56 20.3768 55.2006 17 53.7566ZM42 52.2541V32H51V43.9731C48.6498 47.3508 45.5747 50.1862 42 52.2541Z",
    fill: "#AACED9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationLogoThree);
export default __webpack_public_path__ + "static/media/education-logo-three.9e612e75f4889b8ec96aaee141bea5ba.svg";
export { ForwardRef as ReactComponent };